import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@quality24/design-system';
import { CronRule } from '@quality24/react-order-components';

import useI18nResolvers from '@/inpatient-patient-pwa/i18n/useI18nResolvers';
import { ReasonSelection, resolveReasonSelection } from './utils';

/**
 * `resolveReasonSelection` bound to the error toast and to the app's language,
 * so a reason blocked by its cron rule shows `errorMessageI18N` translated —
 * falling back to the legacy `errorMessage` and then to the app's own default.
 */
const useReasonSelection = () => {
  const { t } = useTranslation();
  const { error: errorToast } = useToast();
  const { resolveI18n } = useI18nResolvers();

  const resolveCronMessage = React.useCallback(
    (cronRule: CronRule) =>
      resolveI18n(cronRule.errorMessageI18N) ||
      cronRule.errorMessage ||
      t('errors.serviceUnavailableAtThisTime'),
    [resolveI18n, t],
  );

  return React.useCallback(
    (selection: ReasonSelection) =>
      resolveReasonSelection(selection, errorToast, resolveCronMessage),
    [errorToast, resolveCronMessage],
  );
};

export default useReasonSelection;
